<template>
  <div class="">
    <div class="vx-row">
      <div class="vx-col w-full ">
        <div id="data-list-list-view" class="data-list-container">
          <vs-table
            :sst="true"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort"
            v-model="selected"
            :total="totalItems"
            pagination
            max-items="10"
            :data="footFallList">
            <template slot="header">
              <h3>
                Footfall List
              </h3>
            </template>
            <template slot="thead">
              <vs-th sort-key="email">
                Name
              </vs-th>
              <vs-th sort-key="username">
                Gender
              </vs-th>
              <vs-th sort-key="website">
                Email
              </vs-th>
              <vs-th sort-key="id">
                Action
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  {{data[indextr].name}}
                </vs-td>

                <vs-td :data="data[indextr].gender">
                  {{data[indextr].gender}}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{data[indextr].email}}
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="EditIcon" @click="updateFootFall(data[indextr].id)"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                class="clickable"/>
                  <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2 clickable"/>-->
                  <feather-icon icon="EyeIcon" @click="footFallDetal(data[indextr].id)"
                                svgClasses="w-5 h-5 hover:text-success stroke-current"
                                class="ml-2 clickable"/>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <!--<pre ref="pre"></pre>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        footFallList: [],
        totalItems: 0,
        selected: [],
        fromDate:'',
        toDate:'',
        activeLoading: false,
        colorx:'success'
      }
    },
    apollo: {
      me: {
        query: gql`
        query me($reminder_date: DateRange, $first: Int!, $page: Int){
            me{
            id
            manager_name
            phone
            email
            address
            api_token
               footfalls(reminder_date: $reminder_date, first: $first, page: $page){
                paginatorInfo{
                  count
                  currentPage
                  firstItem
                  hasMorePages
                  lastItem
                  lastPage
                  perPage
                  total
                }
                data{
                  id
                  name
                  gender
                  email
                  mobile
                  sources
                  suffix
                  reason
                  product
                  brand
                  reminder_date
                  created_at
                  updated_at
                }
              }

           }
         }
        `,
        variables () {
          let frDt = moment().add(1, 'days');
          this.fromDate = moment(frDt).format("yyyy-MM-DD");
          let toDt = moment().add(8, 'days');
          this.toDate = moment(toDt).format("yyyy-MM-DD");
          console.log("fromDate =",this.fromDate );
          console.log("toDate =",this.toDate );
          return {
            reminder_date:{
              from: this.fromDate === 'Invalid date'? "1901-01-01" : this.fromDate,
              to: this.toDate === 'Invalid date' ? "2099-01-01": this.toDate
            },
            first: 10,
            page: this.selectedPgae
          }
        },
        update: (data) => data.me
      }
    },
    watch: {
      me (value) {
        this.$apollo.queries.me.refetch()
        console.log('Me = ', value)
        this.footFallList = value.footfalls.data
        this.pagination = value.footfalls.paginatorInfo
        console.log('this.footFallList', this.footFallList)
        this.totalItems = this.pagination.total
        console.log('this.applicationList Length', this.totalItems)
      },
      '$apollo.loading': function (loading) {
        if (loading === true) {
          this.$vs.loading({
            type: 'sound'
          })
        } else {
          this.$vs.loading.close()
        }
      }
    },
    methods: {
      clearSearch(){
        this.fromDate = '';
        this.toDate = '';
      },
      customFormatter(fromDate, toDate) {
        if(fromDate)
          return moment(fromDate).format('yyyy-MM-DD');
        else
          return moment(toDate).format('yyyy-MM-DD');
      },
      searchByDate(){

      },
      addNewFootfall () {
        this.$router.push('/new_footfall').catch(() => {
        })
      },
      hire () {
        this.$router.push('/hire_agreement').catch(() => {
        })
      },
      footFallDetal (id) {
        this.$router.push('/footfallDetails/' + id).catch(() => {
        })
      },
      updateFootFall (id) {
        this.$router.push('/updateFootfall/' + id).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      }

    },
    components: {
      Datepicker,
    }
  }
</script>
